module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-regular.6035727c.eot";